import React from "react"
import moment from "moment"
import Loading from "../../shared/components/misc/Loading";
import Full from "../../CreditLimit/components/utilization/Full"
import CreditLine from "../../CreditLimit/components/utilization/CreditLine";
import UnlockLater from "../../CreditLimit/components/utilization/UnlockLater"
import UnlockSoon from "../../CreditLimit/components/utilization/UnlockSoon"
import UnlockImminent from "./utilization/UnlockImminent"
import PropTypes from 'prop-types';

function UtilizationCard({
  creditLimit,
  creditLine,
  loading,
  redirectTo,
  screen,
  leadId,
  fcLead
}) {
  if (loading) return <Loading />

  const {
    credit_used = 0.0,
    expected_unlock_date,
    max_potential_credit_limit = 0.0,
    overdue_count = 0,
    is_credit_limit_locked,
  } = creditLimit;

  function getClUtilCard(type) {
    switch(type) {
      case "full":
        return (
          <Full
            creditLimit={creditLimit}
            redirectTo={redirectTo}
            url='/account'
          />
        );
      case "imminent":
        return (
          <UnlockImminent>
            <UnlockLater
              unlockDate={expected_unlock_date}
              redirectTo={redirectTo}
              url='/apply-now'
            />
            <UnlockSoon
              unlockDate={expected_unlock_date}
              redirectTo={redirectTo}
              url='/apply-now'
            />
          </UnlockImminent>
        );
      case "later":
        return (
          <div className='ds-card'>
            <UnlockLater
              unlockDate={expected_unlock_date}
              redirectTo={redirectTo}
              url="/apply-now"
            />
          </div>
        );
      case 'revolving_credit_line':
        return (
          <CreditLine
            actionPath={'/draw_down'}
            creditLimit={creditLimit}
            creditLine={creditLine}
            onClickActionHandler={redirectTo}
            leadId={leadId}
            fcLead={fcLead}
          />
        );
      default:
        return null;
    }
  }

  function getCreditUsedPercentage() {
    return credit_used /  max_potential_credit_limit * 100;
  }

  function getRemainingDaysToUnlock() {
    const dateToday = moment().startOf('day');
    const dueDate   = moment(expected_unlock_date, "YYYY-MM-DD");
    return dueDate.diff(dateToday, 'days');
  }

  function CTAHomeConditionalFlow() {
    if (overdue_count > 0) return null;
    if (!is_credit_limit_locked) {
      return getClUtilCard('revolving_credit_line')
    }

    const remainingDays = getRemainingDaysToUnlock();
    if (remainingDays <= 5) return getClUtilCard("imminent");
    if (getCreditUsedPercentage() >= 100) return getClUtilCard("full");
    return getClUtilCard("later");
  }

  function renderUtilizationCTA() {
    //NOTE: Since this will be re-used to other screen Apply
    // which will have different conditional flow.
    if(screen === "Home") return CTAHomeConditionalFlow();
    return null;
  }

  return  renderUtilizationCTA() ;
}

UtilizationCard.propTypes = {
  /** Credit status summary endpoint response */
  creditLimit: PropTypes.shape({
    active_rcl_offers_amount_total: PropTypes.number,
    amount_balance_outstanding: PropTypes.number,
    amount_to_paydown: PropTypes.number,
    amount_to_paydown_with_interest: PropTypes.number,
    credit_remaining: PropTypes.number,
    credit_used: PropTypes.number,
    expected_unlock_date: PropTypes.string,
    is_credit_limit_locked: PropTypes.bool,
    max_additional_credit_limit: PropTypes.number,
    max_potential_credit_limit: PropTypes.number,
    overdue_count: PropTypes.number,
    target_paydown_percent: PropTypes.number,
    trigger_exposure: PropTypes.number,
  }),
  /** Credit lines endpoint  response */
  creditLine: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    start_timestamp: PropTypes.string,
    end_timestamp: PropTypes.string,
    client_decision: PropTypes.string,
    convenience_fee_type: PropTypes.string,
    option_terms_rate: PropTypes.shape({})
  }),
  /** Loading state indicator */
  loading: PropTypes.bool,
  /** Handler for CTA inside the component, usually router `push` */
  redirectTo: PropTypes.func,
  /** Screen which component will be rendered to, 'Home', etc. */
  screen: PropTypes.string,
  leadId: PropTypes.number,
}

export default UtilizationCard; 



// WEBPACK FOOTER //
// ./src/features/CreditLimit/components/UtilizationCard.js